module.exports = __webpack_public_path__ + "static/media/IMG_20180810_172512.b308c5b0.jpg";